// Open Location Code (Plus Codes) – encode / decode / recover short codes (offline)
const A = '23456789CFGHJMPQRVWX';
const RES = [20, 1, 0.05, 0.0025, 0.000125];
export const OLC_RE = /^([23456789CFGHJMPQRVWX]{2,8}0*\+[23456789CFGHJMPQRVWX]{0,7})(?:[\s,]+(.*))?$/i;

export function olcEncode(lat, lon, len = 10) {
  let la = Math.min(89.9999999, Math.max(-90, lat)) + 90, lo = ((((lon + 180) % 360) + 360) % 360);
  let c = '';
  for (let i = 0; i < 5; i++) {
    const r = RES[i], dl = Math.floor(la / r), dn = Math.floor(lo / r);
    la -= dl * r; lo -= dn * r;
    c += A[dl] + A[dn];
    if (i === 3) c += '+';
  }
  if (len > 10) {
    let rl = 0.000125, rn = 0.000125;
    for (let i = 10; i < len; i++) { rl /= 5; rn /= 4; const r = Math.floor(la / rl), q = Math.floor(lo / rn); la -= r * rl; lo -= q * rn; c += A[r * 4 + q]; }
  }
  return c;
}

const isFull = (code) => code.indexOf('+') === 8;

export function olcDecode(code) {
  const s = code.toUpperCase().replace('+', '').replace(/0+$/, '');
  let la = -90, lo = -180, rl = 20, rn = 20;
  for (let i = 0; i < Math.min(s.length, 10); i += 2) {
    rl = RES[i / 2]; rn = RES[i / 2];
    la += A.indexOf(s[i]) * rl; lo += A.indexOf(s[i + 1] ?? '2') * rn;
  }
  for (let i = 10; i < s.length; i++) { rl /= 5; rn /= 4; const d = A.indexOf(s[i]); la += Math.floor(d / 4) * rl; lo += (d % 4) * rn; }
  return { lat: la + rl / 2, lon: lo + rn / 2 };
}

// short code ("8FVG+X2") + reference position -> nearest matching full code
export function olcRecover(short, refLat, refLon) {
  const s = short.toUpperCase();
  if (isFull(s)) return olcDecode(s);
  const pad = 8 - s.indexOf('+'), res = 20 ** (2 - pad / 2), half = res / 2;
  const full = olcEncode(refLat, refLon).slice(0, pad) + s;
  const p = olcDecode(full);
  if (refLat + half < p.lat && p.lat - res >= -90) p.lat -= res; else if (refLat - half > p.lat && p.lat + res <= 90) p.lat += res;
  if (refLon + half < p.lon) p.lon -= res; else if (refLon - half > p.lon) p.lon += res;
  return p;
}

export const olcIsFull = (code) => isFull(code.toUpperCase());
